/**
 * Add a PRODUCT to cart using CartManager API
 * @param {string} sku
 */
export const addSKUtoCart = async (sku, quantity = 1) => {
    if (window.CartManager === undefined) {
        console.error(`The cart service is not available`)
        return
    }

    try {
        await window.CartManager.updateItem(sku, quantity, null, null, false)
    } catch (error) {
        console.error(`Failed to add item ${sku} in cart: ${error}`)
    }
}
